import { render } from "./AboutYou.vue?vue&type=template&id=4eba8246"
import script from "./AboutYou.vue?vue&type=script&lang=js"
export * from "./AboutYou.vue?vue&type=script&lang=js"

import "./AboutYou.vue?vue&type=style&index=0&id=4eba8246&lang=css"

import exportComponent from "/Users/rulez/Dropbox/Projects/SimpleW/rulez/onboarding2101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__